var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RealtimeSystem',{attrs:{"componentKey":_vm.componentKey,"onAnyEventsSocketScheme":_vm.onAnyEventsSocketScheme},on:{"exportSet":_vm.exportSet}})}
var staticRenderFns = []

export { render, staticRenderFns }